<template>
  <b-modal
    id="manageTagsModal"
    v-model="tagsModal.show"
    title="Manage Tags"
    size="lg"
    ok-title="Close"
    ok-only
    :ok-disabled="saveLoading"
    @hide="onHideModal"
  >
    <b-input-group class="my-3">
      <b-form-input
        v-model="newTagName"
        placeholder="Type and hit enter"
        @keyup.enter="onTagCreate"
      />
      <b-input-group-append>
        <b-button
          :disabled="saveLoading"
          variant="primary"
          @click="onTagCreate"
        >
          <b-spinner
            v-if="saveLoading"
            small
          />
          {{ editingTag ? 'Rename': 'Create' }}
        </b-button>
        <b-button
          v-if="editingTag"
          :disabled="saveLoading"
          variant="secondary"
          @click="cancelEditing"
        >
          Cancel
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <table class="table table-sm">
      <tbody>
        <tr
          v-for="tag of tags.data"
          :key="tag.tagId"
        >
          <td>{{ tag.tagName }}</td>
          <td>{{ tag.updatedDate | toDatetime }}</td>
          <td>{{ tag.updatedBy }}</td>
          <td>
            <b-button
              size="xs"
              variant="outline-info rename-tag-button"
            >
              <font-awesome-icon
                title="Rename"
                :icon="['fas', 'edit']"
                @click="onTagEditClick(tag)"
              />
            </b-button>
            <b-button
              :disabled="deleteInProgress"
              size="xs"
              variant="outline-danger delete-tag-button"
            >
              <font-awesome-icon
                title="Delete"
                :icon="['fas', 'trash']"
                @click="onTagDeleteClick(tag)"
              />
            </b-button>
          </td>
        </tr>
      </tbody>
    </table>
  </b-modal>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import InputWidget from '@/core/components/complex-table/components/InputWidget';
import {axiosClient} from '../../core/services/http.service';
import {deleteTag} from '../../store/modules/sun-model/actions';

const {mapState, mapActions, mapGetters} = createNamespacedHelpers('sunModel');

export default {
  name: 'ManageTagsModal',
  components: {InputWidget},
  data() {
    return {
      saveLoading: false,
      deleteInProgress: false,
      newTagName: '',
      editingTag: null,
      form: {
        tags: [],
      },
    };
  },
  computed: {
    ...mapState(['tagsModal', 'tags']),
  },
  methods: {
    ...mapActions(['hideTagsModal', 'updateFactTable', 'updateDimension', 'createTag', 'updateTag', 'deleteTag', 'loadData']),
    cancelEditing() {
      this.editingTag = null;
      this.newTagName = '';
    },
    async onTagCreate() {
      this.saveLoading = true;
      if (this.editingTag) {
        await this.updateTag({
          ...this.editingTag,
          tagName: this.newTagName,
        });
        this.editingTag = null;
      } else {
        await this.createTag({name: this.newTagName});
      }
      this.newTagName = '';
      this.saveLoading = false;
    },
    onTagEditClick(tag) {
      this.editingTag = tag;
      this.newTagName = tag.tagName;
    },
    async onTagDeleteClick({tagId}) {
      this.deleteInProgress = true;
      await this.deleteTag({id: tagId});
      this.deleteInProgress = false;
      await this.loadData();
    },
    onHideModal() {
      this.hideTagsModal();
    },
  },
};

</script>

<style scoped lang="scss">
  .delete-tag-button,
  .rename-tag-button{
    padding: 0;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border-color: transparent;
  }

</style>
